<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">安全码管理</span>
      </div>
      <div class="right">
          <Button  style="margin-right: 5px" @click="excelModalShow"
            >导入</Button
          >
          <Poptip title="导出" placement="left" trigger="hover">
            <Button style="margin: 0 5px 1px 0">导出</Button>
            <div slot="content">
              <Button
                type="primary"
                style="margin-right: 5px"
                @click="exportExcel(0)"
                >导出当前页</Button
              >
              <Button type="success" @click="exportExcel(1)">导出所有页</Button>
            </div>
          </Poptip>
          <Button type="primary" @click="addModal">新增安全码</Button>
        </div>
      </div>
      <div style="margin:20px 0">
          <span class="subtitle" style="margin-right: 10px">所在仓库:</span>
          <Select v-model="name" style="width: 120px; margin-right: 15px">
            <Option value="全部">全部</Option>
            <Option
              v-for="(item, index) in agent"
              :key="index"
              :value="item.name"
              >{{ item.name }}</Option
            >
          </Select>
          <span class="subtitle" style="margin-right: 10px">当前状态:</span>
          <Select v-model="status" style="width: 100px; margin-right: 15px">
            <Option :value="-1">全部</Option>
            <Option :value="1">未激活</Option>
            <Option :value="2">已激活</Option>
          </Select>
          <span class="subtitle" style="margin-right: 10px">所属类型:</span>
          <Select v-model="type" style="width: 100px; margin-right: 15px">
            <Option :value="-1">全部</Option>
            <Option :value="0">云知印</Option>
            <Option :value="1">智能运维</Option>
          </Select>
          <span class="subtitle">入库时间:</span>
          <DatePicker
            type="daterange"
            v-model="date"
            placeholder="选择时间"
            style="width: 200px; margin-left: 10px"
          ></DatePicker>

          <span class="subtitle" style="margin-left: 15px;margin-right: 10px">自定查找:</span>
           <Input
            v-model="search"
            @on-enter="getData(1)"
            placeholder="搜索..."
            style="width: 180px;"
            >
            </Input>
          <Button style="margin-left: 13px" @click="reset">清空</Button>
    </div>
    <div>
      <Table :columns="columns" :data="data" :loading="loading" @on-sort-change="tableSort"></Table>
      <div class="t-right"  style="margin-top:10px;">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :page-size-opts="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
          :total="total"
          :current="page.p + 1"
          show-elevator
          show-sizer
          show-total
        />
      </div>
       <Spin fix v-if="loading">
          <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
          <div>加载中...</div>
      </Spin>
    </div>

    <Modal :width="500" title="新增安全码" v-model="visible">
      <Form
        ref="formInline"
        :model="current"
        :rules="rule"
        :label-width="70"
      >
        <FormItem prop="name" label="仓库:">
          <!-- <Input v-model="current.name" placeholder="手动输入"/>
          <Select v-model="current.name" style="width: 100px" placeholder="手动选择">
            <Option v-for="(item,index) in agent" :key="index" :value="item.name">{{item.name}}</Option>
          </Select>-->
          <Input v-model="current.name" placeholder="手动输入" style="width:250px;">
            <Select
              v-model="current.name"
              slot="append"
              style="width: 93px"
              placeholder="手动选择"
            >
              <Option
                v-for="(item, index) in agent"
                :key="index"
                :value="item.name"
                >{{ item.name }}</Option
              >
            </Select>
          </Input>
          <div class="describe">请选择安全码入库仓库，新仓库请直接输入名称</div>
        </FormItem>

        <FormItem prop="month" label="运营期:">
          <InputNumber
            :max="100"
            :min="1"
            v-model="current.month"
            :precision="0"
            style="width:150px;"
          ></InputNumber>
            <div class="describe">请输入新增安全码所含的运营期，单位“月”</div>
        </FormItem>
        <FormItem prop="num" label="数量:">
          <InputNumber
            :min="1"
            v-model="current.num"
            :precision="0"
             style="width:150px;"
          ></InputNumber>
        </FormItem>
        <FormItem prop="num" label="类型:">
          <RadioGroup v-model="current.type">
            <Radio label="0">云知印</Radio>
            <Radio label="1">智能运维</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="visible = false">取消</Button>
        <Button @click="modalClick" type="primary">确定</Button>
      </div>
    </Modal>

    <Modal :width="750" title="安全码导入" v-model="excelCode.status">
      <div class="text" style="padding: 10px; line-height: 25px">
        <p>操作步骤：</p>
        <p>1、下载《安全批量导入模板》</p>
        <p>
          2、打开下载表，将对应字段信息输入或粘贴进本表。为保障粘贴信息被有效导入，请使用纯文本或数字
        </p>
        <p>3、信息输入完毕，点击“浏览”按钮，选择excel文档</p>
        <p>4、点击“开始导入”</p>
        <!-- <p>注意事项：安全码为16位数字或英文字母组合，《安全批量导入模板》文档中所有项目都为必填项。</p> -->
        <p style="margin-top: 20px">
          <a :href="imgSrc + '/res/excel/安全码导入模板.xlsx'" target="_blank"
            >立即下载《安全批量导入模板》</a
          >
        </p>
        <div style="position: relative">
          <Input
            readonly
            search
            enter-button="浏览"
            v-model="excelCode.file.name"
            placeholder="选择xlsx文件..."
          />
          <input
            @change="selectExcel"
            accept=".xlsx"
            type="file"
            style="
              position: absolute;
              width: 80px;
              right: 0;
              height: 100%;
              z-index: 100;
              top: 0;
              opacity: 0;
              cursor: pointer;
            "
          />
        </div>
      </div>
      <div slot="footer">
        <Button @click="excelCode.status = false">取消</Button>
        <Button @click="uploadExcel" type="primary">开始上传</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import excel from "@/libs/excel";
import config from "../../config";
export default {
  data() {
    this.statusObj = {
      1: { name: "未激活", color: "#19be6b" },
      2: { name: "已激活", color: "#ed4014" },
      3: { name: "未激活", color: "#19be6b" },
      4: { name: "已失效", color: "#ed4014" },
    };
    return {
      loading: true,
      imgSrc: config.imgSrc,
      excelCode: {
        status: false,
        file: {},
      },
      current: {
        name: "",
        month: 12,
        num: 10,
        type: "0",
      },
      rule: {
        name: [
          {
            required: true,
            type: "string",
            trigger: "blur",
            message: "仓库未选",
          },
        ],
        month: [
          {
            required: true,
            type: "number",
            trigger: "blur",
            message: "运营期必填",
          },
        ],
        num: [
          {
            required: true,
            type: "number",
            trigger: "blur",
            message: "数量必填",
          },
        ],
      },

      name: "全部",
      date: [],
      status: -1,
      type: -1,

      agent: [],
      columns: [
        { key: "id", width: 80, title: "编号" },
        { key: "code", width: 170, title: "安全码" },
        {
          key: "status",
          title: "状态",
          width: 100,
          render: (h, data) => {
            return h(
              "span",
              { style: { color: this.statusObj[data.row.status].color } },
              this.statusObj[data.row.status].name
            );
          },
        },
        {
          key: "type",
          title: "类型",
          width: 120,
          render: (h, data) => {
            let type = {
              0: "云知印",
              1: "智能运维",
            };
            return h("span", {}, type[data.row.type]);
          },
        },
        { key: "month", width: 120, title: "所含运营期" },
        { key: "name", width: 120, title: "仓库" },
        {
          key: "create_time",
          title: "入库时间",
          width: 170,
          sortable: "custom",
          show: true,
          render: (h, data) => {
            return h("span", {}, this.$moment(data.row.create_time));
          },
        },
        { key: "sn", width: 170, title: "设备序列号" },
        {
          key: "bind_time",
          width: 170,
          title: "激活时间",
          sortable: "custom",
          show: true,
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.bind_time ? this.$moment(data.row.bind_time) : ""
            );
          },
        },
        {
          key: "invalid_time",
          title: "有效截止时间",
          sortable: "custom",
          show: true,
          width: 170,
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.invalid_time && data.row.status === 1 ? this.$moment(data.row.invalid_time) : ""
            );
          },
        },
        {
          key: "agent_name",
          title: "合作伙伴",
          width: 300,
          render: (h, data) => {
            return h("span", {}, data.row.codeAgentName || data.row.agent_name);
          },
        },
      ],
      data: [],
      total: 0,

      page: {
        p: 0,
        l: 10,
      },
      visible: false,
      search: "",
    };
  },
  mounted() {
    this.GetOperateStore().then((res) => {
      this.agent = res;
      this.getData();
    });
  },
  methods: {
    uploadExcel() {
      let file = this.excelCode.file;
      if (!file.name) {
        this.$Message.error("请选择excel文档");
        return;
      }
      let fromData = new FormData();
      fromData.append("file", file);
      this.ExcelOperateCode(fromData).then((res) => {
        if (!res.status) {
          this.$Message.error(res.msg);
          return;
        }
        this.excelCode.file = {};
        this.excelCode.status = false;
        this.page.p = 0;
        this.getData();
      });
    },
    selectExcel(e) {
      let file = e.target.files[0];
      if (file) {
        console.log(file);
        if (
          file.type !==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          this.$Message.error("仅支持xlsx格式的excel文档");
          return;
        }
        this.excelCode.file = file;
      }
    },
    excelModalShow() {
      this.excelCode.file = {};
      this.excelCode.status = true;
    },
    exportExcel(type) {
      if (type) {
        // 所有
        let cond = {
          p: 0,
          l: this.total,
        };
        if (this.name !== "全部") {
          cond.name = this.name;
        }
        if (this.status >= 0) {
          cond.status = this.status;
        }
        this.loading = true;
        this.GetOperate(cond).then((res) => {
          this.loading = false;
          this.doExport(res.data);
        });
      } else {
        // 当前页
        let data = JSON.parse(JSON.stringify(this.data));
        this.doExport(data);
      }
    },
    doExport(data) {
      data.map((item) => {
        item.status = item.status
          ? item.status === 1
            ? "未激活"
            : "已激活"
          : "待售";
        item.type=item.type==0?'云知印':'智能运维'
        item.create_time = this.$moment(item.create_time);
        item.bind_time = item.bind_time ? this.$moment(item.bind_time) : "";
        item.invalid_time = item.invalid_time && item.status === 1? this.$moment(item.invalid_time) : "";
        item.agent_name = item.codeAgentName || item.agent_name;
      });
      try {
        let params = {
          title: [],
          key: [],
          autoWidth: true,
          filename: "安全码",
          data: data,
        };
        this.columns.map((item) => {
          params.title.push(item.title);
          params.key.push(item.key);
        });
        console.log(132, params);
        excel.export_array_to_excel(params);
      } catch (error) {
        console.log(error);
      }
    },
    addModal() {
      this.visible = true;
      this.$refs.formInline.resetFields()
    },
    modalClick() {
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          this.current.type = parseInt(this.current.type);
          this.AddOperate(this.current).then((res) => {
            if (res) {
              this.GetOperateStore().then((res) => {
                this.agent = res;
                this.getData();
              });
              this.visible = false;
              this.current = {
                name: "",
                month: 12,
                num: 10,
                type: "0",
              };
            }
          });
        }
      });
    },
    // 表格排序
    tableSort(col) {
      this.page.key = col.key;
      this.page.order = col.order;
      this.getData();
    },
    getData(filter) {
      if(filter){
        this.page.p = 0
      }
      let cond = JSON.parse(JSON.stringify(this.page));
      if (this.name !== "全部") {
        cond.name = this.name;
      }
      if (this.status >= 0) {
        cond.status = this.status;
      }
      if (this.type >= 0) {
        cond.type = this.type;
      }
      console.log('时间',this.date )
      if(this.date[0]&&this.date[1]){
        cond.start = this.$moment(this.date[0],"YYYY-MM-DD");
        cond.end = this.$moment(this.date[1],"YYYY-MM-DD");
      }
      console.log(177, this.search);
      if (this.search !== "") {
        cond.search = this.search;
      }
      this.loading = true;
      this.GetOperate(cond).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.total = res.total;
      });
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
	  reset(){
      this.page.p = 0;
      this.name= "全部"
      this.date=[]
      this.status=-1
      this.type=-1
      this.search=''
    },
    ...mapActions([
      "GetOperateStore",
      "GetOperate",
      "AddOperate",
      "ExcelOperateCode",
    ]),
  },
  watch: {
    name() {
      this.getData(1);
    },
    status() {
      this.getData(1);
    },
    type() {
      this.getData(1);
    },
    date() {
      this.getData(1);
    },
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
